<ng-container *ngIf="!isChatRoute()">
<p-overlaybadge *ngIf="hasUnreadMessages(); else noBadge" value="!" severity="danger" class="badge-pulse" [style]="{'font-size': '1rem', 'font-weight': 'bold'}">
    <button pButton class="floating-chat-button" pTooltip="Chat" showDelay="500" icon="pi pi-comments" (click)="toggleSidebar()">
    </button>
</p-overlaybadge>

<ng-template #noBadge>
    <button pButton class="floating-chat-button" pTooltip="Chat" showDelay="500" icon="pi pi-comments" (click)="toggleSidebar()">
    </button>
</ng-template>
</ng-container>

<!-- Chat Room Sidebar -->
<p-sidebar [(visible)]="chatSidebarVisible" position="right" styleClass="!w-[60rem] !max-w-[100vw] chat-room"
    [baseZIndex]="1200" [dismissible]="false" [closeOnEscape]="true" [showCloseIcon]="false">
    <ng-template pTemplate="header">
        <div class="flex justify-end items-center w-full">
            <button pButton icon="pi pi-times" (click)="toggleSidebar()"
                class="p-button-rounded p-button-sm p-button-text" aria-label="Fermer"></button>
        </div>
    </ng-template>

    <div class="chat-container flex h-full">
        <!-- Chat Room List -->
        <div class="chat-rooms-list w-1/4 border-right p-4">
            <div class="flex justify-between items-center mb-3">
                <h4 class="m-0">Salons</h4>
                <button pButton icon="pi pi-plus" class="p-button-rounded p-button-sm" (click)="openCreateRoomModal()"
                    aria-label="Créer une salle">
                </button>
            </div>
            <div class="room-list mt-3">
                <div *ngFor="let room of chatRooms"
                    class="select-none room-item p-3 mb-2 cursor-pointer rounded-lg transition-colors"
                    [class.active]="currentRoom?.id === room.id" (click)="selectRoom(room)">
                    <div class="flex justify-between items-center">
                        <div>
                            <span class="pi pi-hashtag mr-2"></span>
                            <span>{{ room.name }}</span>
                        </div>
                        <p-badge *ngIf="room.unread_count > 0" [value]="room.unread_count" severity="info"
                            class="ml-auto primary-bg-color"></p-badge>
                    </div>


                </div>

                <div *ngIf="chatRooms.length === 0 && !isLoading" class="text-gray-500 text-sm p-2">
                    Aucun salon disponible
                </div>

                <div *ngIf="isLoading" class="text-gray-500 text-sm p-2">
                    Chargement...
                </div>
            </div>
        </div>

        <!-- Chat Messages Area -->
        <div class="chat-messages-container w-3/4 flex flex-col">
            <!-- Bouton "scroll to bottom" -->
            <div
                class="room-header flex justify-between items-center p-3 border-bottom-1 surface-border !bg-transparent sticky top-0 z-1">
                <h4 class="m-0">{{ currentRoom?.name || 'Sélectionnez un salon' }}</h4>
                <div class="flex gap-2">
                    <button *ngIf="currentRoom && userRole <= 2 && !currentRoom.company_id_if_global" pButton icon="pi pi-pencil"
                        class="p-button-rounded p-button-sm p-button-text" pTooltip="Modifier le salon"
                        tooltipPosition="bottom" (click)="openEditRoomModal()"></button>
                    <button *ngIf="currentRoom" pButton icon="pi pi-users"
                        class="p-button-rounded p-button-sm p-button-text" pTooltip="Voir les membres"
                        tooltipPosition="bottom" (click)="openRoomUsers()">
                    </button>
                </div>
            </div>

            <button *ngIf="showScrollToBottom" pButton icon="pi pi-arrow-down"
                class="scroll-to-bottom-button p-button-rounded p-button-sm shadow-lg" (click)="scrollToBottom()"
                pTooltip="Aller en bas" tooltipPosition="left">
            </button>

            <div class="messages-area flex-grow p-4 overflow-y-auto" #messageContainer>
                <!-- Room header with refresh button -->
                <!-- Rest of your messages area code -->


                <div *ngIf="!currentRoom" class="flex items-center justify-center h-full text-gray-400">
                    Sélectionnez un salon pour commencer à discuter
                </div>

                <div *ngIf="currentRoom && messages.length === 0 && !isLoading"
                    class="flex items-center justify-center h-full text-gray-400">
                    Aucun message dans ce salon. Soyez le premier à écrire!
                </div>

                <div *ngIf="isLoading" class="flex items-center justify-center h-full text-gray-400">
                    Chargement des messages...
                </div>
                <div *ngIf="isLoadingMore" class="text-center text-gray-400 text-sm mb-2">
                    Chargement des anciens messages...
                </div>
                <div class="messages-container">
                    <ng-container *ngFor="let message of messages; let i = index">
                        <div *ngIf="isFirstMessageOfDay(message, i)" class="date-divider">
                            <span class="date-label">{{ message.created_at | date:'dd MMMM yyyy':'':'fr' }}</span>
                        </div>

                        <!-- Message -->
                        <div [ngClass]="{
                            'message-right': isCurrentUserMessage(message), 
                            'message-left': !isCurrentUserMessage(message),
                            'important-message': message.is_priority
                         }" class="message">

                            <div [ngStyle]="{'background-color': !isCurrentUserMessage(message) ? getUserColor(message.user_id) : ''}"
                                class="message-content cursor-pointer hover:opacity-80 transition duration-150"
                                (click)="openMessageMenu($event, message)" [id]="'message-' + message.id">

                                <div class="message-header flex gap-4 items-center justify-between">
                                    <div>
                                        <span class="message-author">{{ message.user?.firstname || 'Compte' }} {{
                                            message.user?.name || 'supprimé' }}</span>
                                        <span class="message-admin text-red-500 font-bold ml-2" *ngIf="message.is_admin">ADMIN</span>
                                        <span class="message-time ml-2 text-gray-500">{{ message.created_at |
                                            date:'HH:mm' }}</span>
                                    </div>
                                </div>

                                <!-- Si ce message est une réponse -->
                                <div *ngIf="message.reply_to"
                                    class="reply-preview text-sm text-gray-500 border-l-2 px-2 mb-1 cursor-pointer bg-gray-200 rounded-lg"
                                    (click)="$event.stopPropagation(); scrollToOrLoadMessage(message.reply_to.id)">
                                    ↪ <strong>{{ message.reply_to.user?.firstname || 'Compte' }} {{
                                        message.reply_to.user?.name || 'supprimé' }}</strong>:
                                    <div class="overflow-hidden text-overflow-ellipsis whitespace-nowrap max-w-full">
                                        <span [innerHTML]="message.reply_to.content | slice:0:100"></span>
                                        <span *ngIf="message.reply_to.content?.length > 100">...</span>
                                    </div>
                                </div>

                                <div class="message-body" [ngClass]="{'mt-2': message.reply_to}" [innerHTML]="message.highlightedContent"></div>
                            </div>
                        </div>

                    </ng-container>
                </div>
            </div>

            <!-- Input Area -->
            <div class="message-input-area p-3 border-top">
                <div *ngIf="replyToMessage"
                    class="reply-banner flex items-center justify-between p-2 bg-gray-100 border rounded mb-2">
                    <div>
                        <strong>En réponse à :</strong>
                        <span class="text-gray-700">
                            {{ replyToMessage.user?.firstname }} {{ replyToMessage.user?.name }} —
                            <span [innerHTML]="replyToMessage.content | slice:0:80"></span>
                        </span>
                    </div>
                    <button pButton icon="pi pi-times" class="p-button-rounded p-button-text p-button-sm"
                        (click)="cancelReply()" pTooltip="Annuler la réponse"></button>
                </div>

                <app-chat-room-input #chatInput [context]="context" [loading]="isSendingMessage"
                    [currentRoom]="currentRoom" (messageSent)="onMessageSent($event)">
                </app-chat-room-input>
            </div>
        </div>
    </div>
    <p-menu #messageMenu [model]="menuItems" [popup]="true" appendTo="body"></p-menu>
</p-sidebar>

<p-dialog [(visible)]="createRoomModalVisible" header="Créer un nouveau salon"
    [style]="{width: '450px', maxWidth: '90%'}" [modal]="true" [draggable]="false" [resizable]="false">
    <div class="flex flex-col gap-4">
        <div class="field">
            <label for="roomName" class="block mb-2">Nom du salon</label>
            <input id="roomName" type="text" pInputText [(ngModel)]="newRoom.name" class="w-full"
                placeholder="Entrez le nom du salon">
        </div>

        <div class="field">
            <label for="roomUsers" class="block mb-2">Utilisateurs</label>
            <p-multiSelect id="roomUsers" [(ngModel)]="newRoom.user_ids" [options]="companyUsers"
                optionLabel="display_name" optionValue="id" placeholder="Sélectionnez des utilisateurs" [filter]="true"
                appendTo="body" styleClass="w-full ">
            </p-multiSelect>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2">
            <button pButton (click)="createRoomModalVisible = false" label="Annuler" class="p-button-text"></button>
            <button pButton (click)="createRoom()" label="Créer" [disabled]="!newRoom.name || !newRoom.user_ids.length"
                [loading]="isCreatingRoom"></button>
        </div>
    </ng-template>
</p-dialog>

<!-- ✅ MODALE ÉDITION SALON -->
<p-dialog [(visible)]="editRoomModalVisible" header="Modifier le salon" [style]="{width: '450px', maxWidth: '90%'}"
    [modal]="true" [draggable]="false" [resizable]="false">
    <div class="flex flex-col gap-4">
        <div class="field">
            <label for="editRoomName" class="block mb-2">Nom du salon</label>
            <input id="editRoomName" type="text" pInputText [(ngModel)]="editRoom.name" class="w-full"
                placeholder="Nom du salon" />
        </div>

        <div class="field">
            <label for="editRoomUsers" class="block mb-2">Utilisateurs</label>
            <p-multiSelect id="editRoomUsers" [(ngModel)]="editRoom.user_ids" [options]="companyUsers"
                optionLabel="display_name" optionValue="id" placeholder="Sélectionnez des utilisateurs" [filter]="true"
                appendTo="body" styleClass="w-full" selectedItemsLabel="{0} utilisateurs sélectionnés"></p-multiSelect>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="flex justify-between w-full">
            <button pButton label="Supprimer le salon" icon="pi pi-trash" class="p-button-danger p-button-text"
                (click)="confirmDeleteRoom()"></button>

            <div class="flex gap-2">
                <button pButton label="Annuler" class="p-button-text" (click)="editRoomModalVisible = false"></button>

                <button pButton label="Enregistrer" [disabled]="!editRoom.name || !editRoom.user_ids.length"
                    [loading]="isUpdatingRoom" (click)="updateRoom()"></button>
            </div>
        </div>
    </ng-template>
</p-dialog>


<p-dialog [(visible)]="roomUsersModalVisible" header="Membres du salon" [style]="{width: '400px', maxWidth: '90%'}"
    [modal]="true">
    <div class="user-list">
        <div *ngFor="let user of roomUsers" class="flex items-center py-3 border-bottom-1 surface-border">
            <div class="user-avatar flex justify-center items-center w-8 h-8 rounded-full mr-3"
                [style.background-color]="getUserColor(user.id)">
                <span class="text-white font-medium">{{ getInitials(user) }}</span>
            </div>
            <span>{{ user.firstname }} {{ user.name }} <span class="text-sm text-gray-400">({{user.id}})</span></span>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <button pButton (click)="roomUsersModalVisible = false" label="Fermer" class="p-button-text"></button>
    </ng-template>
</p-dialog>

<p-toast position="bottom-right"></p-toast>
<p-confirmDialog></p-confirmDialog>